import { FETCH_FORM_DETAILS, FETCH_FORM_DETAILS_SUCCESS, FETCH_FORM_DETAILS_FAILURE } from '../actions';

const initialState = {
 formdetail: [],
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_FORM_DETAILS:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_FORM_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        formdetail: action.data
      };
    case FETCH_FORM_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        formdetail: []
      };
    default:
      return state;
  }
}